
import { Component, Inject, Vue, Ref } from "vue-property-decorator";
import { Container } from "inversify";
// @ts-ignore
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { AuthStore } from "../../../common/src/stores/AuthStore";
import { EventInput, EventApi } from "@fullcalendar/core";
import { UserFavoriteConferenceListStore } from "../stores/user/UserFavoriteConferenceListStore";
import { ConferenceEditStore } from "../stores/conference/ConferenceEditStore";
import { ConferenceDestroyStore } from "../stores/conference/ConferenceDestroyStore";
import EditEventModal from "../molecules/conference/EditEventModal.vue";
import ViewEventModal from "../molecules/conference/ViewEventModal.vue";
import LoadingOverlay from "../../../common/src/components/LoadingOverlay.vue";
import { focusOnFirstInvalidInput } from "../../../common/src/form/utils";
import { handleError } from "../../../common/src/utility/errorUtils";
import { OrganizationCollectionStore } from "../stores/user/OrganizationCollectionStore";
import { UserFavoriteOrganizationListStore } from "../stores/user/UserFavoriteOrganizationListStore";
import UserDashboardMap from "../molecules/user-dashboard/UserDashboardMap.vue";
import { FirstTimeDashboardVisitSidebarStore } from "../molecules/user-dashboard/FirstTimeDashboardVisitSidebarStore";

import * as components from "../molecules/industry-analytics/index";
import analyticMap from "../molecules/industry-analytics/analyticMap";
import { UserActivityLogsListStore } from "../stores/user/UserActivityLogsListStore";
import { UserVisitedOrganizationListStore } from "../stores/user/UserVisitedOrganizationListStore";
import NoRecords from "../../../common/src/components/NoRecords.vue";
import { UserActivityLogListItem } from "@gsx/common/src/types/http/dashboard/userActivityLog";
import {
    Action,
    isAdmin,
    MAX_FREE_ORGANIZATION_SEARCH,
    QuiltySubscriptionPlanType,
} from "@gsx/common";
import { RequestListStore } from "../../../landing/src/stores/member/requests/RequestListStore";

import SubmitRequestModal from "../../../landing/src/molecules/request-form/SubmitRequestModal.vue";
import SubmitThirdpartyRequestModal from "../../../landing/src/molecules/request-form/SubmitThirdpartyRequestModal.vue";
import { ConferenceListStore } from "../stores/conference/ConferenceListStore";
import { ConferenceFilterStore } from "../stores/conference/ConferenceFilterStore";
import { OrganizationListStore } from "../stores/organization/OrganizationListStore";
import { StatisticsStore } from "../stores/organization/StatisticsStore";
import {
    isFullyRegistered,
    hasAccessToDashboard,
    hasActiveQuiltySubscription,
} from "../../../common/src/utility/entity/user";
import { NotificationStore } from "../../../common/src/stores/NotificationStore";
import { PaymentService } from "../../../landing/src/utility/payment/PaymentService";
import Loader from "../molecules/components/Loader.vue";
import { IndividualSubscriptionRedirectModalStore } from "../../../common/src/subscription-quote/IndividualSubscriptionRedirectModalStore";
import {
    FeedbackModalStore,
    FeedbackModalType,
} from "../../../common/src/feedback/FeedbackModalStore";
import TierProgressBar from "../../../common/src/components/TierProgressBar.vue";
import CalendarEvent from "../molecules/user-dashboard/CalendarEvent.vue";
import FavoritedCalendarEvent from "../molecules/user-dashboard/FavoritedCalendarEvent.vue";
import GlobalCalendarEvent from "../molecules/user-dashboard/GlobalCalendarEvent.vue";
import NotificationEvent from "../molecules/user-dashboard/NotificationEvent.vue";
import SocialFeed from "../molecules/flashNews/SocialFeed.vue";
import { FlashNewsListStore } from "../stores/flashNews/FlashNewsListStore";
import GlobalCalendarCard from "../molecules/user-dashboard/GlobalCalendarCard.vue";
import { TabStore } from "../../../common/src/stores/general/TabStore";
import TabNavItem from "../../../common/src/components/TabNavItem.vue";

enum Tab {
    Favorite = "Favorited Global Events",
    Upcoming = "Upcoming Global Events",
}

@Component({
    components: {
        TierProgressBar,
        SubmitRequestModal,
        SubmitThirdpartyRequestModal,
        NoRecords,
        UserDashboardMap,
        EditEventModal,
        ViewEventModal,
        LoadingOverlay,
        FullCalendar,
        Loader,
        CalendarEvent,
        FavoritedCalendarEvent,
        GlobalCalendarEvent,
        NotificationEvent,
        SocialFeed,
        GlobalCalendarCard,
        TabNavItem,
        ...components,
    },
})
export default class UserDashboardView extends Vue {
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);
    statisticStore: StatisticsStore = this.container.get(StatisticsStore);

    conferenceListStore: ConferenceListStore = this.container.get(ConferenceListStore);
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    userFavoriteConferenceListStore: UserFavoriteConferenceListStore = this.container.get(
        UserFavoriteConferenceListStore,
    );
    readonly tabStore: TabStore<Tab> = new TabStore(Tab.Upcoming);
    conferenceEditStore: ConferenceEditStore = this.container.get(ConferenceEditStore);
    conferenceDestroyStore: ConferenceDestroyStore = this.container.get(ConferenceDestroyStore);
    isEditModalVisible = false;
    isViewModalVisible = false;
    isQuiltyThirdPartySubscriptionModalVisible = false;
    @Ref("fullcalendar") readonly calendar!: HTMLDivElement;
    @Ref("launchpadUserVisitedOrganizations")
    readonly launchpadUserVisitedOrganizationsEle!: HTMLElement;
    @Ref("launchpadQuiltyFlashNews")
    readonly launchpadQuiltyFlashNewsEle!: HTMLElement;
    @Ref("launchpadUpcomingEvents")
    readonly launchpadUpcomingEventsEle!: HTMLElement;

    currentFullCalendarDate = new Date();
    Action = Action;
    userFavoriteOrganizationListStore: UserFavoriteOrganizationListStore = this.container.get(
        UserFavoriteOrganizationListStore,
    );
    organizationCollectionStore: OrganizationCollectionStore = this.container.get(
        OrganizationCollectionStore,
    );
    analyticMap = analyticMap;
    readonly userActivityLogList: UserActivityLogsListStore =
        this.container.get(UserActivityLogsListStore);
    isRequestModalVisible: boolean = false;
    readonly listStore: RequestListStore = this.container.get(RequestListStore);

    readonly paymentService: PaymentService = this.container.get(PaymentService);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    readonly individualSubscriptionRedirectModalStore: IndividualSubscriptionRedirectModalStore =
        this.container.get(IndividualSubscriptionRedirectModalStore);
    feedbackModalStore: FeedbackModalStore = this.container.get(FeedbackModalStore);
    firstTimeDashboardVisitSidebarStore: FirstTimeDashboardVisitSidebarStore = this.container.get(
        FirstTimeDashboardVisitSidebarStore,
    );

    readonly userVisitedOrganizationListStore: UserVisitedOrganizationListStore =
        this.container.get(UserVisitedOrganizationListStore);
    readonly flashNewsListStore: FlashNewsListStore = this.container.get(FlashNewsListStore);
    readonly conferenceFilterStore: ConferenceFilterStore =
        this.container.get(ConferenceFilterStore);
    created() {
        this.conferenceFilterStore.resetFilters();
        this.conferenceListStore.afterDate = new Date();
        this.conferenceListStore.pageSize = 20;

        this.userFavoriteConferenceListStore.load().catch(handleError);
        this.userFavoriteOrganizationListStore.load().catch(handleError);
        this.userActivityLogList.load().catch(handleError);
        this.conferenceListStore.load().catch(handleError);
        this.statisticStore.load().catch(handleError);
        this.flashNewsListStore.load().catch(handleError);
        this.userVisitedOrganizationListStore.load().catch(handleError);

        if (this.$route.query.quoteRequest) {
            this.isRequestModalVisible = this.$route.query.quoteRequest === "true";
        } else if (this.$route.query.recommendOrganization) {
            this.feedbackModalStore.open(FeedbackModalType.RecommendOrganization);
        }

        if (!localStorage.getItem("firstTimeDashboard") && !this.authStore.user?.cookiesAccepted) {
            this.firstTimeDashboardVisitSidebarStore.open();
            localStorage.setItem("firstTimeDashboard", "visited");
        }
    }

    get currentUserActivityLogList() {
        return this.userActivityLogList.items?.filter(
            (logListItem: UserActivityLogListItem) =>
                logListItem.user?.firstName === this.authStore.user?.firstName,
        );
    }

    mounted() {
        this.launchpadQuiltyFlashNewsEle.addEventListener("scroll", this.paginateQuiltyFlashNews);

        this.launchpadUserVisitedOrganizationsEle.addEventListener(
            "scroll",
            this.paginateVisitedOrganizations,
        );

        if (this.launchpadUpcomingEventsEle) {
            this.launchpadUpcomingEventsEle.addEventListener("scroll", this.paginateUpcomingEvents);
        }

        this.authStore.me();
    }

    beforeDestroy() {
        this.launchpadQuiltyFlashNewsEle.removeEventListener(
            "scroll",
            this.paginateQuiltyFlashNews,
        );

        this.launchpadUserVisitedOrganizationsEle.removeEventListener(
            "scroll",
            this.paginateVisitedOrganizations,
        );

        if (this.launchpadUpcomingEventsEle) {
            this.launchpadUpcomingEventsEle.removeEventListener(
                "scroll",
                this.paginateUpcomingEvents,
            );
        }
    }

    get organizationCount(): number | undefined {
        return this.statisticStore.item?.organizationCount;
    }

    get countriesCount(): number | undefined {
        return this.statisticStore.item?.countriesCount;
    }

    get calendarPlugins() {
        return [dayGridPlugin, timeGridPlugin, interactionPlugin];
    }

    get favoritedConferences() {
        return this.authStore.user!.favorites?.conferenceIds || [];
    }

    get favoritedOrganizations() {
        return this.authStore.user!.favorites?.organizationIds || [];
    }

    get favoritedAnalytics() {
        return this.authStore.user!.favorites?.analytics || [];
    }

    get _hasAccessToDashboard() {
        return hasAccessToDashboard(this.authStore.user);
    }

    get organizationCountText() {
        const tracker = this.authStore.user!.organizationSearchTracker;
        const maxSearches = MAX_FREE_ORGANIZATION_SEARCH;

        const exhausted = `You've exhausted your ${MAX_FREE_ORGANIZATION_SEARCH} organization views per month. \n\nSubscribe for premium membership to get unlimited organization searches and views.`;
        const currentcount = "Remaining Organization Views: ";

        if (tracker) {
            if (new Date(tracker.date).getMonth() === new Date().getMonth()) {
                const remaining = maxSearches - tracker.count;
                return remaining === 0 ? exhausted : currentcount + remaining;
            } else {
                return currentcount + maxSearches;
            }
        } else {
            return maxSearches;
        }
    }

    get presentAndFutureEvents() {
        return this.userFavoriteConferenceListStore.filteredItemsByFutureDate.sort(
            (a, b) => a.startDate.getTime() - b.startDate.getTime(),
        );
    }

    get calendarEvents(): EventInput[] {
        return this.conferenceListStore.items || [];
    }

    get mapEvents() {
        return (this.userFavoriteConferenceListStore.items || []).filter((conference) =>
            this.favoritedConferences.includes(conference.conferenceid),
        );
    }

    get isSubscribed() {
        return hasAccessToDashboard(this.authStore.user);
    }

    get isSubscriptionQuiltyEnterprise() {
        return (
            this.isQuiltySubscribed &&
            this.authStore.user?.quiltySubscription?.plan === QuiltySubscriptionPlanType.Enterprise
        );
    }

    get isQuiltySubscribed() {
        return hasActiveQuiltySubscription(this.authStore.user);
    }

    get finishedRegistration() {
        return isFullyRegistered(this.authStore.user);
    }

    get affiliatedOrg() {
        return this.authStore.user?.organization;
    }

    get isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
        );
    }

    paginateQuiltyFlashNews() {
        this.paginateListOnScroll(
            this.launchpadQuiltyFlashNewsEle,
            this.flashNewsListStore.infiniteScroll,
        );
    }

    paginateVisitedOrganizations() {
        this.paginateListOnScroll(
            this.launchpadUserVisitedOrganizationsEle,
            this.userVisitedOrganizationListStore.infiniteScroll,
        );
    }

    paginateUpcomingEvents() {
        this.paginateListOnScroll(
            this.launchpadUpcomingEventsEle,
            this.conferenceListStore.infiniteScroll,
        );
    }

    paginateListOnScroll(ele: HTMLElement, scrollFunction: () => void) {
        if (ele.scrollTop + ele.clientHeight >= ele.scrollHeight) {
            if (scrollFunction) {
                scrollFunction();
            }
        }
    }

    affiliationRequest() {
        window.location.href = "/member/request-affiliation";
    }

    convertToFavoriteName(id: string) {
        let name = "";

        const conference = this.conferenceListStore.items?.find((item) => item.conferenceid === id);
        const organization = this.organizationListStore.items?.find(
            (item) => item.organizationid === id,
        );
        const analytic = analyticMap[id];

        if (conference) {
            name = conference.name;
        } else if (organization) {
            name = organization.organizationName;
        } else if (analytic) {
            name = analytic.component;
        }

        return name;
    }

    userActivityClicked(userActivityLog: UserActivityLogListItem) {
        if (
            userActivityLog.action === Action.FavoriteRemoved ||
            userActivityLog.action === Action.FavoriteAdded
        ) {
            const id = userActivityLog.value || "";
            const conference = this.conferenceListStore.items?.find(
                (item) => item.conferenceid === id,
            );
            const organization = this.organizationListStore.items?.find(
                (item) => item.organizationid === id,
            );
            const analytic = analyticMap[id];

            if (conference) {
                this.conferenceEditStore.setConference(conference);
                this.canManageEvent ? this.displayEditModal() : this.displayViewModal();
            } else if (organization) {
                this.$router.push(`/organizations/${id}`);
            } else if (analytic) {
                this.$router.push(`/industry-analytics`);
            }
        }
    }

    handleEventClick({ event }: { event: EventApi }) {
        const conference = (this.userFavoriteConferenceListStore.items || []).find(
            (conference) => conference.conferenceid === event.id,
        );

        if (!conference) {
            console.warn("Could not find conference referenced by clicked event.");
            return;
        }

        this.conferenceEditStore.setConference(conference);
        this.canManageEvent ? this.displayEditModal() : this.displayViewModal();
    }

    handleEventClickFromList(conferenceid: string) {
        const conference = (this.userFavoriteConferenceListStore.items || []).find(
            (conference) => conference.conferenceid === conferenceid,
        );

        if (!conference) {
            console.warn("Could not find conference referenced by clicked event.");
            return;
        }

        this.conferenceEditStore.setConference(conference);
        this.canManageEvent ? this.displayEditModal() : this.displayViewModal();
    }

    get canManageEvent(): boolean {
        return (
            isAdmin(this.authStore.user) ||
            this.authStore.user!.userid === this.conferenceEditStore.conference!.userId
        );
    }

    subscribeUser() {
        this.individualSubscriptionRedirectModalStore.open();
    }

    headToUserProfile() {
        window.location.href = "/member/profile";
    }

    displayViewModal() {
        this.isViewModalVisible = true;
    }

    hideViewModal() {
        this.isViewModalVisible = false;
    }

    displayEditModal() {
        this.isEditModalVisible = true;
    }

    hideEditModal() {
        this.isEditModalVisible = false;
    }

    displayQuiltySubscriptionModal() {
        this.isQuiltyThirdPartySubscriptionModalVisible = true;
    }

    hideQuiltySubscriptionModal() {
        this.isQuiltyThirdPartySubscriptionModalVisible = false;
    }

    async editEvent() {
        await this.conferenceEditStore.submit();

        if (this.conferenceEditStore.failed) {
            focusOnFirstInvalidInput();
        } else {
            this.hideEditModal();
            await this.userFavoriteConferenceListStore.reload();
        }
    }

    async destroyEvent() {
        await this.conferenceDestroyStore.delete(this.conferenceEditStore.conference!.conferenceid);

        if (!this.conferenceDestroyStore.failed) {
            this.hideEditModal();
            await this.userFavoriteConferenceListStore.reload();
        }
    }

    getOrgName(organizationid: string) {
        const org = this.organizationListStore.items?.find(
            (org) => org.organizationid === organizationid,
        );
        return org ? org.organizationName : "No Org";
    }

    organizationUrl(organizationId: string) {
        return `/dashboard/organizations/${organizationId}`;
    }

    showRequestModal() {
        this.isRequestModalVisible = true;
    }

    closeModal() {
        this.isRequestModalVisible = false;
    }

    onSubmitRequest() {
        this.closeModal();
        this.listStore.reload().catch(handleError);
    }

    onQuiltySubmitRequest() {
        this.hideQuiltySubscriptionModal();
    }

    async quiltyBasicSubscription() {
        try {
            await this.paymentService.purchasePlan(QuiltySubscriptionPlanType.Basic);
        } catch (e) {
            this.notificationStore.warning("Could not initialize a payment process.");
        }
    }

    get todaysDate() {
        return new Date();
    }

    get hardcodedVisitedOrgs() {
        return this.userVisitedOrganizationListStore.items?.filter((item) => {
            return (
                item.organizationName !== ("Global Space Exchange, Inc." || "Trident Systems, Inc.")
            );
        });
    }

    get Tab() {
        return Tab;
    }
}
